import handleMultipleOption from '../actions/handleMultipleOption'
import validateCurrentField from '../actions/validateCurrentField'
import changeLocale from '../actions/changeLocale'
import unFocusLastField from '../actions/unFocusLastField'
import isLocaleAwareInput from '../actions/isLocaleAwareInput'
import isMultipleInput from '../actions/isMultipleInput'
import handleSingleOption from '../actions/handleSingleOption'
import handlePopulateOptionsForStatePath from '../actions/handlePopulateOptionsForStatePath'
import isLoggedInUserSameAsCurrentUser from '../actions/isLoggedInUserSameAsCurrentUser'
import isLoggedIn from 'modules/app/actions/isLoggedIn'
import loadTranslations from 'modules/app/actions/loadTranslations'

export default [
  isLocaleAwareInput,
  {
    true: [
      isLoggedInUserSameAsCurrentUser,
      {
        true: [
          loadTranslations,
          {
            true: [],
            false: []
          },
          changeLocale
        ],
        false: []
      },
      isLoggedIn,
      {
        false: [
          loadTranslations,
          {
            true: [],
            false: []
          },
          changeLocale
        ],
        true: []
      },
      isMultipleInput,
      {
        true: [handleMultipleOption],
        false: [
          handleSingleOption,
          {
            populate: [handlePopulateOptionsForStatePath],
            notPopulate: []
          },
          unFocusLastField
        ]
      },
      validateCurrentField()
    ],
    false: [
      isMultipleInput,
      {
        true: [handleMultipleOption],
        false: [
          handleSingleOption,
          {
            populate: [handlePopulateOptionsForStatePath],
            notPopulate: []
          },
          unFocusLastField
        ]
      },
      validateCurrentField()
    ]
  }
]



// WEBPACK FOOTER //
// ./src/modules/client/chains/selectOption.js